import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup/validator';
import { QuoteStatus } from 'quotes/enums';

export const updateQuotesSchema = (availableStatuses: QuoteStatus[]) =>
  yup.object().shape({
    closeConfidence: numberSchemaWithTransform()
      .label(t('labelCloseConfidence'))
      .nullable()
      .min(0, t('errorCloseConfidenceOutOfBounds'))
      .max(100, t('errorCloseConfidenceOutOfBounds')),
    status: yup.string().label(t('labelStatus')).nullable().oneOf(availableStatuses),
    closeDate: yup.string().label(t('labelCloseDate')).nullable(),
    validSince: yup.string().nullable(),
    validUntil: yup.string().nullable(),
    verticalMarket: yup.object().label(t('labelVerticalMarket')).nullable(),
  });
